import React, { useState} from "react";
import "./dashboard.css";
import EmployeeReportTracking from "./EmployeeReportTracking";
import ApplicationUsageReport from "./ApplicationUsageReport";
import TimeEntriesReport from "./TimeEntriesReport";
import GenerateAttendanceReport from "./GenerateAttendanceReport";
import LocationWiseReport from "./LocationWiseReport";
import ArthatrackExcelReport from "./ArthatrackExcelReport";
import AttendanceReportHistory from "./AttendanceReportHistory";

const Reports = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedReportId, setSelectedReportId] = useState(1); // Default to first report

  const reports = [
    { id: 1, title: "Generate Employee Tracking Report" },
    { id: 2, title: "Generate Application Usage Report" },
    { id: 3, title: "Generate Timesheet Entries Report" },
    { id: 4, title: "Generate Attendance Report" },
    { id: 5, title: "Location-wise Attendance Report" },
    { id: 6, title: "Generate Arthatrack Sheet" },
    { id: 7, title: "Attendance Report History" },
  ];
  
  return (
    <div className="container-fluid p-0 m-0">
      <div className="row" style={{ backgroundColor: "#EFF0F4", position: "relative" }}>
        <div className="col-12 col-md-12 align-items-center mt-3  border-bottom text-black-50">
          <div className="relative w-64">
            <input
              type="text"
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-1000 focus:outline-none focus:border-gray-300 focus:ring-0 mb-3 shadow-sm"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Reports Table */}
        <div
          className="col-12 col-md-3 text-center border-end text-black-50 bg-white shadow rounded"
          style={{ height: "75vh" }}
        >
          <div className="d-flex flex-column h-100">
            {/* Table Header */}
            <p className="mt-2 border-bottom text-black-50 fw-bold w-full items-center pb-3">
              Report Types
            </p>

            {/* Table Body - Make this div scrollable */}
            <div
              className="overflow-auto flex-grow-1"
              style={{
                height: "0",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {reports.map((report) => (
                <div
                  key={report.id}
                  onClick={() => setSelectedReportId(report.id)}
                  className={`items-center px-1 py-1 shadow-sm text-center`}
                  style={{
                    backgroundColor: "#ffffff",
                    color: selectedReportId === report.id ? "#FF8800" : "#333",
                    marginBottom: "1rem",
                    border:
                      selectedReportId === report.id
                        ? "2px solid #FF8800"
                        : "1px solid #eeeeee",
                    display: "flex",
                    cursor: "pointer",
                    borderRadius: "20px",
                  }}
                >
                  <div className=" items-center">
                    <div className=" flex items-center">
                      <div className="ml-3">
                        <div
                          className="text-sm font-medium text-gray-900"
                          style={{
                            color:
                              selectedReportId === report.id
                                ? "#FF8800"
                                : "#333",
                          }}
                        >
                          {report.title}
                        </div>
                        <div className="text-sm text-gray-1000">
                          {report.description}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className="col-12 col-md-9 px-4 shadow-sm rounded overflow-y-auto "
          style={{ maxHeight: "75vh" }}
        >
          {selectedReportId === 1 && <EmployeeReportTracking />}
          {selectedReportId === 2 && <ApplicationUsageReport />}
          {selectedReportId === 3 && <TimeEntriesReport />}
          {selectedReportId === 4 && <GenerateAttendanceReport />}
          {selectedReportId === 5 && <LocationWiseReport />}
          {selectedReportId === 6 && <ArthatrackExcelReport />}
          {selectedReportId === 7 && <AttendanceReportHistory />}

        </div>
      </div>
    </div>
  );
};

export default Reports;
